import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Box, Flex, Heading} from "rebass";
import styled from "styled-components";

import PopupForm from "../../components/Modals/PopupForm";
import SettingProfileCard from '../../components/Cards/SettingProfileCard';
 
export const VerticalScroll = styled(Flex)`
  display: flex; /* [1] */
  flex-direction: row;
  flex-wrap: wrap; /* [1] */
  overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}`

const ConfigMemberPanel = props => {
	const {handleSubmit, form, items, title } = props;
	return (
		<Box>
			{items &&
			<Fragment>
				<Box width={1} p={2} pb={3} pl={3}>
					<Heading>Active {title} ({items.filter(item => item.activated !== false).length})</Heading>
                        <VerticalScroll pt={3}>
                            {items.filter(item => item.activated !== false ).map(item => {
                                    return (
                                        <Box
                                             width={[1 / 2, 1 / 3, 1 / 4, 1 / 5]}
                                             p={'10px'}
                                         >
                                            <PopupForm
                                                key={item.id}
                                                FormComponent={form}
                                                handleSubmit={handleSubmit}
                                                initialValues={item}
                                                ShowComponent={(props) => (
                                                    <SettingProfileCard detail={item} {...props}/>
                                                )}
                                            />
                                        </Box>
                                    )
                            })}
                        </VerticalScroll>
				</Box>

				<Box width={1} p={2} pb={3} pl={3}>
					<Heading>Inactive {title} ({items.filter(item =>  item.activated === false).length})</Heading>
                        <VerticalScroll pt={3}>
                            {items.filter(item => item.activated === false).map(item => {
                                return (
                                    <Box
                                        width={[1 / 2, 1 / 3, 1 / 4, 1 / 5]}
                                        p={'10px'}
                                    >
                                        <PopupForm
                                            key={item.id}
                                            FormComponent={form}
                                            handleSubmit={(handleSubmit)}
                                            initialValues={item}
                                            ShowComponent={(props) => (
                                                <SettingProfileCard detail={item} {...props}/>
                                            )}
                                        />
                                    </Box>
                            )})}
                        </VerticalScroll>
				</Box>
			</Fragment>
			}
		</Box>
	);
};

ConfigMemberPanel.propTypes = {
	handleSubmit: PropTypes.func,
	form: PropTypes.element,
	items: PropTypes.array,
	title: PropTypes.string,
};

export default ConfigMemberPanel;
